import { reactive, toRefs, onBeforeMount, onBeforeUnmount, onMounted, computed, nextTick, watch,getCurrentInstance  } from 'vue'
import { useStore } from 'vuex'
import useReceiveMessage, { getCanvasLimitHeight } from '@/hooks/useReceiveMessage'
import useLoading3D from '@/hooks/useLoading3D'
import useSpeechSynthesis from '@/hooks/useSpeechSynthesis'
import { $enum } from '@/global'
import {$config} from '@/global/index'
import {enterOrExitUavSimulateModule, switchOpenGuid, switchView, resetView, switchUnlockUav,forceGainFocus} from '@/webapi'
import { createTraining, deleteTraining,saveUserTrainingSetting } from '@/service'
import RectDrawer from '@/utils/drawer/RectDrawer'

enum PageName {
    加载中=1,
    飞行=2,
    成绩=3
}

enum MassageType {
    无=0,
    悬停=1,
    自转=2,
    八字=3,
    降落=4,
    解锁=5
}


export default function useFlying(
    timeBoxRef:any,
    timeBox:any,
    progressRef:any,
    flyCanvasRef:any,
): any {
    const store = useStore()
    const { proxy } = getCurrentInstance() as any
    const typeMap = new Map([
        ['notifyRunningParam', 'notifyRunningParam'], //运行数据回调
        ['loadResourceFail', 'loadResourceFail'], //加载模型失败
        ['loadSceneResource', 'loadSceneResource'], //加载模型完成
        ['modelLoading', 'modelLoading'], //加载模型进度
        ['initializeEngineProgress', 'initializeEngineProgress'], //引擎初始化
        ['extraLoadModelFiles','extraLoadModelFiles'], //额外的模型文件列表
        ['exitSimulateModuleSuccess','exitSimulateModuleSuccess'], //退出模拟模块成功
    ])
    const state = reactive({
        sceneImage: $config.FILE_ROOT_PATH + store.state.persistence.currentUavInfo.sceneImageUrl,
        uavId: store.state.persistence.currentUavInfo.uavId,
        nestId: store.state.persistence.currentUavInfo.nestId,
        trainingId: store.state.persistence.currentUavInfo.trainingId,
        stationdId: store.state.persistence.stationId,
        sceneInfo:store.state.persistence.currentUavInfo.sceneInfo,
        resourceFileList:store.state.persistence.currentUavInfo.sceneInfo?.resourceFileList[0] || [],
        windSpeedIndex:store.state.persistence.currentUavInfo.windSpeedIndex,
        windDirectionIndex:store.state.persistence.currentUavInfo.windDirectionIndex,
        connectStatus: $enum.SWITCH_STATUS.OFF, // 遥控器连接状态
        lockStatus:$enum.SWITCH_STATUS.OFF,
        guidStatus:store.state.persistence.userTrainSettingInfo?.enableGuide, //引导状态
        characterMode:0,//视角类型,0为第三人称,1为第一人称,2为飞手视角
        containerWidth: 0 as any, // 容器宽度
        currentPage:PageName.加载中, //当前页面,
        pixiApp: store.state.viewData.pixiInstance, //pixi实例
        loading3D:{
            title:'新手教学',
            description:'学习遥控器基本操作',
            pageType:'训练',
        },
        finish:false,//是否训练完成
        drawer:null as any, // 圆形绘制器实例
        totalTime:0,//总时间
        pageVisible:true, //页面是否可见
        engineProgress:0,
        timer:null as any, // 倒计时计时器
        promptText:'', //提示文本
        fpsStatus:60,
        canSetFps:true,
        collisionAlarm:false,
        currentWindSpeed:'0.0',
        resultType:null,
        rightJoyStickYawTip:-1, // 右摇杆方向提示icon的角度 0-360 ，如果是-1 则不显示
        leftJoyStickYawTip:-1, // 左摇杆方向提示icon的角度 0-360 ，如果是-1 则不显示
        isShowMessage:false, //是否显示消息
        messageText:'', //消息文本
        messageType:'', // info、error、success
        messageTime:0,
        backByExitSimulateModule:false,
    })

    const flyingState = reactive({
        totalSeconds: -1, // 飞行总时间 秒
        currentSeconds: 0, // 当前时间 秒
        uavStatusList: [],
        currentStepIndex:0,
        altitude:0,  //高度
        horizonalSpeed:0,//速度
        courseAngle:0, //航向角
        angularSpeed:0,//角速度
        uavIconAngle:0, //无人机图标角度
        realTimeAngleOffset:0,//航向夹角
        isShowAlarm:false,
        currentMessage:MassageType.无,
        onGround:false,
        isReady:false,
    });

    const resultConent = computed(() => {
        return state.resultType == 0?'任务失败':'恭喜你完成教学'
    });

    const subResultContent = computed(() => {
        return state.resultType == 0?'飞机已坠毁，即将重新开始教学任务。':'快去试试科目训练吧'
    });

    const { speak, stop} = useSpeechSynthesis()

    const gradTotalTime = computed(() => {
        const totalSeconds = state.totalTime;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = Math.floor(totalSeconds - minutes * 60); // 关键修改：计算真正的剩余秒数
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    });

    const loadingProgess = computed(() => {
        if(engineInitialized.value){
            return loadingState.progressValue;
        }else{
            return (state.engineProgress * 100).toFixed(2);
        }
    });

    watch(()=>state.isShowMessage,(newVal,oldval)=>{
        if(newVal === false){
            proxy?.vknMessage.close();
        }
    })

    watch(()=>state.messageText,(newVal,oldval)=>{
        if(newVal != oldval && newVal != '' && newVal != null && state.isShowMessage){
            proxy?.vknMessage.close();
            let icon = state.messageType == 'error'? 'gjts' : 'yjzldy';
            showMessage(newVal, state.messageTime, icon, true)
        }
    })



     ///////////////////////////////////////////////////////



    const { loadingState, setLoadingStatus,engineInitialized, handleOpenPDF,setExtraFileMap, showOrHideEngineView } = useLoading3D(state.stationdId, state.resourceFileList, proxy)

     const { handleBack } = useReceiveMessage(typeMap, (type: string, data: any) => {
        if (type === 'notifyRunningParam') {
            const { horizonalSpeed, yaw, taskData, joyStickMode, unLockStatu,yawAngleSpeed,homingData,onGround,openGuidStatu,notifyKeyList,triggerReset,characterMode, isReady,finishReset,fps,currentWindSpeed } = data.data || {}
            const { stepNameList, currentStepIndex,finish,targetTime, currentTime,isPass, mapYaw,mapPosition,totalTime,overLimit, collisionAlarm, crash, leftJoyStickYawTip, rightJoyStickYawTip,realTimeAngleOffset} = taskData || {}
            const {show,message,type,time} =  taskData.showMessage || {}
            Object.assign(state,{
                lockStatus:unLockStatu,
                connectStatus:joyStickMode,
                totalTime:totalTime,
                collisionAlarm,
                currentWindSpeed:currentWindSpeed?.toFixed(1) || '0.0',
                rightJoyStickYawTip:rightJoyStickYawTip == undefined?-1:rightJoyStickYawTip,
                leftJoyStickYawTip:leftJoyStickYawTip == undefined?-1:leftJoyStickYawTip,
                guidStatus:openGuidStatu,
                characterMode:characterMode,
                isShowMessage:show,
                messageText:message,
                messageType:type,
                messageTime:time,
            })
            if(state.canSetFps){
                state.fpsStatus = fps;
            }
            if (notifyKeyList && notifyKeyList.length > 0)
            {
                notifyKeyList.forEach((item: string) => {
                    if(item == "Escape")
                    {
                        handleBack('Escape');
                    }else if(item == "F11"){
                        window.listenEvent.emit('toggle-full-screen');
                    }
                });
            }
            if(triggerReset)
            {
                handleSwitch("reset",true)
            }
            if(finishReset)
            {
                if(state.drawer){
                    state.drawer.reset(mapYaw);
                }
            }
            if(!finish){
                if(state.finish){
                    state.finish = false;
                }
                 // 一次性更新飞行状态
                const prevIsReady = flyingState.isReady;
                Object.assign(flyingState, {
                    uavStatusList: stepNameList,
                    currentStepIndex,
                    altitude: homingData?.verticalDistance?.toFixed(2) || '0.00',
                    horizonalSpeed: horizonalSpeed?.toFixed(2) || '0.00',
                    angularSpeed: yawAngleSpeed.toFixed(1) || '0.0',
                    courseAngle: yaw?.toFixed(0) || '0',
                    realTimeAngleOffset:realTimeAngleOffset !== undefined?realTimeAngleOffset?.toFixed(0) || '0':undefined,
                    totalSeconds:targetTime,
                    currentSeconds:currentTime?.toFixed(0),
                    uavIconAngle:mapYaw?.toFixed(0),
                    isShowAlarm:overLimit == 1?true:false,
                    onGround:onGround,
                    isReady:isReady,
                })
                // 广播 isReady 状态变化给布局组件（仅在状态变化时广播）
                if (isReady && isReady !== prevIsReady) {
                    window.listenEvent.emit('is-ready-change', isReady);
                }

                if(!state.drawer){
                    state.drawer = new RectDrawer(flyCanvasRef.value,{x:mapPosition.x,y:mapPosition.y,yaw:mapYaw})
                }
                if(state.drawer && state.currentPage == PageName.飞行 && unLockStatu ==  $enum.SWITCH_STATUS.ON){
                    state.drawer.updateCompass({
                        x:mapPosition.x,
                        y:mapPosition.y,
                        yaw:mapYaw
                    })
                }
            }

            if(finish && !state.finish){
                proxy?.vknMessage.close();
                Object.assign(state,{
                    finish:true,
                    resultType:crash?0:isPass?1:1
                })
                state.currentPage = PageName.成绩
            }
        }

        if(type === 'initializeEngineProgress'){
            state.engineProgress = data.data?.progress || 0
        }

        if (type === 'loadSceneResource') {
             //加载成功
            // clearInterval(loadingState.timer)
            state.currentPage = PageName.飞行;
            enterOrExitUavSimulateModule({
                enter:true,
                uavSpecificationId:state.uavId,
                nestId:state.nestId,
                userId:store.state.persistence.userInfo.userId,
                tenantId:store.state.persistence.currentTenantId,
                appId:store.state.persistence.userInfo.appId,
                volume:store.state.persistence.sounds.droneSound,
                canvasLimitHeight:getCanvasLimitHeight(store.state.persistence.resolution),
                openGuidStatu:state.guidStatus,
                trainingData:{
                    id:state.trainingId,
                    sceneInfo:state.sceneInfo,
                    windSpeedRange:state.windSpeedIndex,
                    windDirectionIndex:state.windDirectionIndex,
                    forbidSaveResult:'',
                    specifiedJoystick:store.state.persistence.userTrainSettingInfo.joystickSpecification
                }
            })
        }

         if (type === 'modelLoading') {
             //加载中
             // const { progressData} = data.data || {}
             // loadingState.loadingStatus = progressData
             // initTimer();
             setLoadingStatus(data.data);

         }

         if(type ==='extraLoadModelFiles')
         {
             setExtraFileMap(data.data);
         }

         if(type === 'exitSimulateModuleSuccess'){
            if(state.backByExitSimulateModule){
                handleBack();
            }
         }
    })
    ///////////////////////////////////////////////////////  状态

    ///////////////////////////////////////////////////////  计算属性
    // 遥控器连接图标
    const connectIcon = computed(() => {
        return state.connectStatus? require("@assets/images/connect.png"): require("@assets/images/disconnect.png")
    })



    const currentTime = computed(() => {
        const progress = flyingState.currentSeconds / flyingState.totalSeconds;
        const remainTime = flyingState.totalSeconds - flyingState.currentSeconds;
        let adjustedRight;

        if (timeBox.value) {
            const rect = timeBox.value.getBoundingClientRect();
            const parentRect = timeBox.value.parentElement.getBoundingClientRect();
            const boxWidth = rect.width;
            const parentWidth = parentRect.width;

            // 计算剩余空间
            const remainingSpace = parentWidth - boxWidth;
            adjustedRight = remainingSpace * progress;
            if(flyingState.currentSeconds > 0){
               timeBox.value.style.right = `${adjustedRight}px`;
            }else if(flyingState.currentSeconds == 0){
                timeBox.value.style.right = `0px`;
            }
        }
        if (progressRef.value) {
            if(flyingState.currentSeconds >= 0){
                progressRef.value.style.width = `${adjustedRight}px`;
            }else if(flyingState.currentSeconds == 0){
                progressRef.value.style.width = `0px`;
            }
        }

        const minutes = Math.floor(remainTime / 60);
        const seconds = (remainTime % 60).toFixed(0);
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    })

    const lockIcon = computed(() => {
        if(state.lockStatus ==  $enum.SWITCH_STATUS.ON){
            return require("@/assets/images/unlock.png");
          }
          return require("@/assets/images/lock.png");
    })
    ///////////////////////////////////////////////////////  方法

    const showMessage = (message: string, duration?:number, icon?:string, useVoice?:true | false) => {
        if(useVoice){
            speak(message)
        }
        proxy?.vknMessage.warning({
            message: message,
            duration:duration !== null && duration !== undefined?duration:3000,
            offset: 100,
        }, icon)
    }

    //成绩页面中的重新开始按钮
    async function handleRestart(isBeforeUnload?:false | true){
        window?.playClick()
         //1. 调用后端接口生成一个训练id
         let param = {
            sceneId:store.state.persistence.currentUavInfo.sceneInfo.id,
            uavSpecificationId:state.uavId,
            userId:store.state.persistence.userInfo.userId,
            stationId:state.stationdId,
        }
        const {code, data} = await createTraining(param);
        if(code != $enum.EnumResult.SUCCESS){
            // showMessage("创建新训练失败！")
            return;
        }
        const {trainingId} = data as any || {};
        //2. 通过后端返回的trainingid更新store里面的trainingid
        store.commit('persistence/setCurrentUavInfo', {
            ...store.state.persistence.currentUavInfo,
            trainingId: trainingId
        });
        //3. 调用webapi接口重新开始
        resetView({
            trainingId,
            windSpeedRange:state.windSpeedIndex,
            windDirectionIndex:state.windDirectionIndex,
            openGuidStatu:state.guidStatus
        })
        //1. 重置飞行状态页面的状态,
        Object.assign(flyingState,{
            totalSeconds: -1, // 飞行总时间 秒
            currentSeconds: 0, // 当前时间 秒
            uavStatusList: [],
            currentStepIndex:0,
            altitude:0,  //高度
            horizonalSpeed:0,//速度
            courseAngle:0, //航向角
            realTimeAngleOffset:flyingState.realTimeAngleOffset !== undefined?0:undefined,//航向夹角
            angularSpeed:0,//角速度
            currentMessage:MassageType.无,
            onGround:false,
            uavIconAngle:0
        })
        //5. 重置进度条
        if (timeBox.value) {
            timeBox.value.style.right = `0%`;
        }
        if (progressRef.value) {
            progressRef.value.style.width = `0%`;
        }
        if(!isBeforeUnload){
            state.currentPage = PageName.飞行;
            proxy?.vknMessage.close();
            flyingState.currentMessage = MassageType.解锁;
        }else{
            state.currentPage = PageName.加载中;
        }
    }


    /**
     * 切换状态
     * @param type
     */
    async function handleSwitch(type:string,fromNotify = false){
        window?.playClick()
        if(type == 'guid'){
            //关闭开启引导
            const enableGuide = !state.guidStatus
            let params = {
                userId: store.state.persistence.userInfo.userId,
                tenantId: store.state.persistence.currentTenantId,
                sceneTypeId: store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-1].id,
                enableGuide
            }
            let {code,data,message} = await saveUserTrainingSetting(params) as any
            if(code != $enum.EnumResult.SUCCESS || data != true){
                return;
            }

            store.commit('persistence/setUserTrainingSetting', {
                ...store.state.persistence.userTrainSettingInfo,
                enableGuide
            })
            switchOpenGuid({open:enableGuide?1:0});
        }else if(type == 'view'){
            //切换视角
            switchView()
        }else{
            //重置
            if(flyingState.currentStepIndex > 0){

                if(!fromNotify)
                {
                    resetView({
                        windSpeedRange:state.windSpeedIndex,
                        windDirectionIndex:state.windDirectionIndex,
                        openGuidStatu:state.guidStatus
                    })
                }
                if (timeBox.value) {
                    timeBox.value.style.right = `0%`;
                }
                if (progressRef.value) {
                    progressRef.value.style.width = `0%`;
                }
                flyingState.currentMessage = MassageType.解锁;
            }
        }
    }

    const handlerResiz = ()=>{
        if(state.drawer){
            state.drawer.resizeHandler();
        }
    }

    function handleBackCallback(type?: string){
        state.backByExitSimulateModule = true;
        enterOrExitUavSimulateModule({enter:false});
    }

    function handleBeforeUnload(e: BeforeUnloadEvent) {
        window.speechSynthesis.cancel()
        store.commit("viewData/setEnterScene", false);
        if(state.currentPage == PageName.成绩) {
            handleRestart(true);
        }
    }

    function handleLock(){
        if(state.lockStatus == $enum.SWITCH_STATUS.ON && !flyingState.onGround){
            return;
        }
        let lock = -1;
        if(state.lockStatus == $enum.SWITCH_STATUS.OFF){
            lock = 1;
        }else{
            lock = 0;
        }
        window?.playClick()
        switchUnlockUav({unlock:lock})
    }

    function handleVisibilityChange(){
        if(document.visibilityState == "hidden"){
            state.pageVisible = false;
            state.canSetFps = false;
        }else{
            setTimeout(() => {
                state.pageVisible = true;
            }, 300);
            setTimeout(() => {
                state.canSetFps = true;
            }, 1500);
        }
    }
    function handleKeyDown(event:any)
    {
        if (state.currentPage == PageName.成绩) {
            if (event.key == "Escape") {
                handleBack('Escape');
            }
            return;
        }
        forceGainFocus({key: event.key});
    }



    ///////////////////////////////////////////////////////  生命周期
    onBeforeMount(() => {})
    onMounted(async () => {
        await nextTick();
        if(timeBoxRef.value){
            state.containerWidth = timeBoxRef.value?.offsetWidth;
        }
        window.addEventListener('resize', handlerResiz)
        window.addEventListener('beforeunload', handleBeforeUnload)
        document.addEventListener('visibilitychange', handleVisibilityChange);
        document.addEventListener('keydown', handleKeyDown);
    })

    onBeforeUnmount(() => {
        // if(!state.finish){
        //     deleteTraining({trainingId:state.trainingId})
        // }
        if(!state.backByExitSimulateModule){
            enterOrExitUavSimulateModule({enter:false})
        }
        showOrHideEngineView(false)
        store.commit("viewData/setEnterScene", false);
        store.commit("persistence/setStationId", null);
        if(state.drawer){
            state.drawer.destroy();
        }
        proxy?.vknMessage.close();

        if(state.timer){
            clearTimeout(state.timer);
            state.timer = null;
        }
        store.commit("viewData/setEnterScene", false);
        window.removeEventListener('resize', handlerResiz);
        window.removeEventListener('beforeunload', handleBeforeUnload);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        document.removeEventListener('keydown', handleKeyDown);
    })

    ///////////////////////////////////////////// 测试

    return {
        ...toRefs(state),
        ...toRefs(loadingState),
        ...toRefs(flyingState),
        $config,
        $enum,
        connectIcon,
        currentTime,
        engineInitialized,
        lockIcon,
        gradTotalTime,
        loadingProgess,
        resultConent,
        subResultContent,
        handleBack,
        handleBackCallback,
        handleRestart,
        handleSwitch,
        handleLock,
        handleOpenPDF
    }
}
